import { financeAPI } from "../../axios";

export const actions = {

    //RCD
    CreateRCD(context, data){
        return financeAPI.post(`RCD/Create`, data);
    },
    GetAllRCD(context, data){
        return financeAPI.get(`RCD/All/${data}`);
    },
    UpdateRCD(context, data){
        return financeAPI.put(`RCD/Update/${data.id}`, data);
    },
    RemoveRCD(context, data){
        return financeAPI.delete(`RCD/Delete/${data}`);
    },
    GetSingleRCD(context, data){
        return financeAPI.get(`RCD/${data}`);
    },
    GetDraftRCD(context, data){
        return financeAPI.get(`RCD/Campus/Draft/${data.campusId}/${data.cycle}`);
    },
    GetPostedRCD(context, data){
        return financeAPI.get(`RCD/Campus/Posted/${data.campusId}/${data.cycle}`);
    },
    GetAvailableRCD(context, campusId){
        return financeAPI.get(`RCD/Collections/Available/${campusId}`);
    },
    AddCollectionToRCD(context, data){
        return financeAPI.post(`RCD/Collections/Add/${data.rcdId}`, data.collections);
    },
    RemoveCollectionFromRCD(context, data){
        return financeAPI.delete(`RCD/Collections/${data.rcdId}/${data.collectionId}`);
    },
    PostRCD(context, data){
        return financeAPI.post(`RCD/Post/${data}`);
    }
}